import type { Notoriety } from '../api/types';

/** Paleta do GDD 08. Fill do nick; `target` só sublinhado / chrome. */
export const NICK = {
  /** Companheiro de GRUPO. Verde, e só dele — `rel === 3`. */
  party: '#4ec95a',
  /** Colega de guilda ou aliança — `rel === 1`. Era verde também, e as duas
   *  coisas ficavam indistinguíveis: a prop se chamava `inParty` e o dado que
   *  a alimentava era guilda. */
  guild: '#7ad6a0',
  murderer: '#e04a3f',
  enemy: '#e8913a',
  criminal: '#b8b8b8',
  innocent: '#6f9dff',
  monster: '#c9c2b2',
  dummy: '#c4a574',
  guard: '#c9a227',
  duelista: '#e6c452',
  npc: '#d4b56a',
  target: '#ffe066',
  war: '#e04a3f',
  /** [GM] e [ADMIN] no nick. */
  staff: '#e6c14a'
} as const;

export function marcaStaff(cargo: number): '' | 'GM' | 'ADMIN' {
  if (cargo === 2) return 'ADMIN';
  if (cargo === 1) return 'GM';
  return '';
}

export function cargoDePapel(role: string | undefined): number {
  if (role === 'admin') return 2;
  if (role === 'gm') return 1;
  return 0;
}

/** `[GM] Nick` ou `[ADMIN] [TAG] Nick`. Ações (tell, guilda) continuam no nome cru. */
export function nomeComMarca(nome: string, cargo: number, guildTag = ''): string {
  const marca = marcaStaff(cargo);
  const base = guildTag ? `[${guildTag}] ${nome}` : nome;
  return marca ? `[${marca}] ${base}` : base;
}

export const NICK_WIRE = {
  innocent: 0,
  criminal: 1,
  murderer: 2,
  duelista: 3
} as const;

const LABEL_WIRE: Record<Notoriety, number> = {
  inocente: NICK_WIRE.innocent,
  criminoso: NICK_WIRE.criminal,
  assassino: NICK_WIRE.murderer,
  duelista: NICK_WIRE.duelista
};

export const NICK_GM_LABEL: Record<Notoriety, string> = {
  inocente: 'Blue',
  criminoso: 'Criminal',
  assassino: 'PK',
  duelista: 'Duelista'
};

export function wireFromLabel(label: string | null | undefined): number {
  if (label === 'criminoso') return NICK_WIRE.criminal;
  if (label === 'assassino') return NICK_WIRE.murderer;
  return NICK_WIRE.innocent;
}

export function labelFromWire(n: number): Notoriety {
  if (n === NICK_WIRE.criminal) return 'criminoso';
  if (n === NICK_WIRE.murderer) return 'assassino';
  if (n === NICK_WIRE.duelista) return 'duelista';
  return 'inocente';
}

export function nickFill(args: {
  notoriety: number;
  /** Companheiro de grupo de verdade. */
  inParty?: boolean;
  /** Colega de guilda ou aliança. */
  guildAlly?: boolean;
  enemyGuild?: boolean;
  dead?: boolean;
  oculto?: boolean;
}): string {
  let hex: string = NICK.innocent;
  // O grupo vem PRIMEIRO, acima até do inimigo de guerra: um inimigo que
  // esteja no seu grupo aparece como grupo, que é o que importa quando ele
  // está morrendo ao seu lado.
  if (args.inParty) hex = NICK.party;
  else if (args.enemyGuild) hex = NICK.enemy;
  else if (args.guildAlly) hex = NICK.guild;
  else if (args.notoriety === NICK_WIRE.murderer) hex = NICK.murderer;
  else if (args.notoriety === NICK_WIRE.duelista) hex = NICK.duelista;
  else if (args.notoriety === NICK_WIRE.criminal) hex = NICK.criminal;
  if (args.oculto) return mixGray(hex, 0.92);
  return args.dead ? mixGray(hex, 0.50) : hex;
}

export function nickFillFromLabel(
  label: string | null | undefined,
  extra?: { dead?: boolean; inParty?: boolean; guildAlly?: boolean; enemyGuild?: boolean }
): string {
  return nickFill({ notoriety: wireFromLabel(label), ...extra });
}

/** Interpola cada canal em direção a 0x80. */
export function mixGray(hex: string, t: number): string {
  const n = hex.replace('#', '');
  const r = parseInt(n.slice(0, 2), 16);
  const g = parseInt(n.slice(2, 4), 16);
  const b = parseInt(n.slice(4, 6), 16);
  const mix = (c: number) => Math.round(c + (0x80 - c) * t);
  return `#${[mix(r), mix(g), mix(b)].map(c => c.toString(16).padStart(2, '0')).join('')}`;
}

export function isNotoriety(v: string): v is Notoriety {
  return v === 'inocente' || v === 'criminoso' || v === 'assassino' || v === 'duelista';
}

export { LABEL_WIRE };
